var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41085",
    "data-name": "Group 41085",
    transform: "translate(22341 18280)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15538",
    "data-name": "Rectangle 15538",
    width: 16,
    height: 16,
    transform: "translate(-22341 -18280)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ikon",
    transform: "translate(-22343 -18281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36998",
    "data-name": "Path 36998",
    d: "M10,7h0A3,3,0,0,1,7,4H7a.5.5,0,0,1,.5-.5h5A.5.5,0,0,1,13,4h0A3,3,0,0,1,10,7Zm6,8.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1,0-1h1v-.8A4.675,4.675,0,0,1,8.08,9.677a.731.731,0,0,0,0-1.354A4.675,4.675,0,0,1,5.5,3.8V3h-1a.5.5,0,0,1,0-1h11a.5.5,0,0,1,0,1h-1v.8a4.675,4.675,0,0,1-2.58,4.523.731.731,0,0,0,0,1.354A4.675,4.675,0,0,1,14.5,14.2V15h1a.5.5,0,0,1,.5.5ZM13.5,15v-.8a3.706,3.706,0,0,0-1.966-3.6,1.73,1.73,0,0,1,0-3.2A3.706,3.706,0,0,0,13.5,3.8V3h-7v.8A3.706,3.706,0,0,0,8.466,7.4a1.73,1.73,0,0,1,0,3.2A3.706,3.706,0,0,0,6.5,14.2V15Z",
    fill: "#b2b9c4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.c38b000770a7d6389400b54683a3ef3d.svg";
export { ForwardRef as ReactComponent };